import { ISmartLinksContext } from 'components/MCTextEditor/MCEditorContextInterfaces'

import { deleteSmartLink } from './deleteSmartLink'
import { createInsertSmartLink } from './insertSmartLink'
import { readonlySmartLink } from './readonlySmartLink'
import { selectSmartLink } from './selectSmartLink'
import { createUpdateSmartLink } from './updateSmartLink'

export const createSmartLinkMiddlewares = (context: ISmartLinksContext) => {
  const { createButton, cloneSmartLink, getLabelById } = context
  return [
    createInsertSmartLink(createButton, cloneSmartLink),
    readonlySmartLink,
    selectSmartLink,
    deleteSmartLink,
    createUpdateSmartLink(getLabelById),
  ]
}
